import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlDomSanitizerPipe } from './html-dom-sanitizer.pipe';

@NgModule({
  declarations: [HtmlDomSanitizerPipe],
  exports: [HtmlDomSanitizerPipe],
  imports: [
    CommonModule
  ]
})
export class DomSanitizerModule { }
